import type { ReactNode } from "react";
import Sidebar from "@/components/sidebar";
import { cn } from "@/lib/utils";

interface AppShellProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function AppShell({ children, className, contentClassName }: AppShellProps) {
  return (
    <div className={cn("flex h-screen overflow-hidden", className)}>
      <Sidebar />
      <div
        className={cn(
          "flex-1 flex flex-col overflow-hidden ml-[3.25rem] sm:ml-[3.75rem] md:ml-[4.25rem] lg:ml-[3.75rem] xl:ml-[4.25rem] 2xl:ml-[5.25rem]",
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
}
